import React from 'react';
import { motion } from 'framer-motion';
import { 
  TrendingUp, 
  Shield, 
  Users, 
  Globe,
  Award,
  CheckCircle,
  Star,
  Target
} from 'lucide-react';

const AboutUs = () => {
  // Using existing professional image from assets
  const aboutImage = require('../assets/business-team-singapore.jpg');

  const achievements = [
    { icon: Users, number: '50K+', label: 'Active Traders' },
    { icon: Globe, number: '150+', label: 'Countries Served' },
    { icon: TrendingUp, number: '$2B+', label: 'Trading Volume' },
    { icon: Award, number: '10+', label: 'Years Experience' }
  ];

  return (
    <section id="about-us" className="about-us-section">
      <div className="about-us-container">
        
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="about-us-header"
        >
          <div className="about-us-badge">
            <Target className="about-us-badge-icon" />
            <span>About ChartLine Brokerage</span>
          </div>
          <h2 className="about-us-title">
            Empowering Traders with
            <span className="about-us-title-accent"> Professional Excellence</span>
          </h2>
          <p className="about-us-subtitle">
            We are a leading brokerage firm committed to providing exceptional trading experiences 
            through innovative technology, competitive pricing, and unparalleled customer service.
          </p>
        </motion.div>

        {/* Main Content Grid */}
        <div className="about-us-content-grid">
          
          {/* Left Side - Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="about-us-image-container"
          >
            <div className="about-us-image-wrapper">
              <img
                src={aboutImage}
                alt="ChartLine Brokerage Team"
                className="about-us-image"
              />
              <div className="about-us-image-overlay">
                <div className="about-us-image-badge">
                  <Star className="h-5 w-5 text-yellow-400" />
                  <span className="text-white font-semibold">Trusted by Thousands</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Side - Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="about-us-content"
          >
            <div className="about-us-story">
              <h3 className="about-us-story-title">Our Story</h3>
              <p className="about-us-story-text">
                Founded with a vision to democratize access to global financial markets, 
                ChartLine Brokerage has grown to become a trusted partner for traders worldwide. 
                We combine cutting-edge technology with deep market expertise to deliver 
                exceptional trading experiences.
              </p>
              <p className="about-us-story-text">
                Our commitment to transparency, innovation, and customer success has made us 
                a preferred choice for both novice and professional traders seeking reliable 
                brokerage services.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Achievements Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="about-us-achievements"
        >
          {achievements.map((achievement, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.8 + index * 0.1 }}
              viewport={{ once: true }}
              className="about-us-achievement-card"
            >
              <div className="about-us-achievement-icon">
                <achievement.icon className="h-6 w-6 lg:h-8 lg:w-8 text-emerald-600" />
              </div>
              <div className="about-us-achievement-content">
                <div className="about-us-achievement-number">{achievement.number}</div>
                <div className="about-us-achievement-label">{achievement.label}</div>
              </div>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default AboutUs; 